<mat-toolbar class="header-toolbar-wrapper" color="primary">
  <div class="header-toolbar">
    <div class="logo-container" [routerLink]="['/']" routerLinkActive="is-active">
      <img alt="Profile Deutsch" class="logo-image" src="../../../../assets/images/pd-logo.png"/>
    </div>
    <!-- Standalone Button Group -->
    <div [class.header-menu-wrapper--search-expanded]="searchExpanded" class="header-menu-wrapper">
      @if (authService.isLoggedIn()) {
        <app-header-search (expandedChange)="searchExpanded = $event"></app-header-search>
      }
      @if (!searchExpanded) {
        @for (item of standaloneItems; track item) {
          <div class="standalone-items">
            <div [routerLink]="item.route" class="header-menu-button" attr.aria-label="Button zu {{item?.name}} "
                 mat-menu-item>
              <span class="menu-button-group">
                <mat-label class="menu-text">{{ item.name }}</mat-label>
              </span>
            </div>
          </div>
        }
        <!-- Bt Bereiche Dropdown -->
        @if (dropdownItems.length !== 0) {
          <div
            [matMenuTriggerFor]="menu"
            aria-label="weitere Bereiche"
            class="header-menu-button"
            mat-menu-item>
            <span class="menu-button-group">
              <mat-icon class="expand-icon">expand_more</mat-icon>
              @if (standaloneItems.length !== 0) {
                <mat-label class="menu-text"
                >weitere Bereiche</mat-label>
              } @else {
                <mat-label class="menu-text">Bereiche</mat-label>
              }
            </span>
          </div>
        }
      }
    </div>

    <!-- Login Button Group -->
    <div class="login-wrapper">
      @if (!authService.isLoggedIn()) {
        <a [routerLink]="['/login']"
           aria-label="LoginButton" class="login-button" mat-flat-button color="primary">
          <span class="login-button-group">
            <mat-label class="login-text" id="login-plaintext" routerLinkActive="is-active">Anmelden</mat-label>
            <mat-icon class="material-icon menu-icon" fontIcon="login"></mat-icon>
          </span>
        </a>
      }

      @if (authService.isLoggedIn()) {
        <a [matMenuTriggerFor]="userDropdown" aria-label="UserButton"
           class="login-button" mat-flat-button color="primary">
          <span class="login-button-group">
            <span class="email-wrapper">
              <mat-label class="login-text" id="email-text">{{ authService.getUser() }}</mat-label>
              @if (unreadCount > 0) {
                <span [attr.aria-label]="unreadCount + ' ungelesene Benachrichtigungen'" class="unread-dot"
                      matTooltip="Ungelesene Benachrichtigungen">{{ unreadLabel }}</span>
              }
            </span>
            <mat-icon class="material-icon menu-icon" fontIcon="account_circle"></mat-icon>
          </span>
        </a>
      }
      <mat-menu #userDropdown="matMenu" xPosition="before">
        <button [routerLink]="['/account']" mat-menu-item
                routerLinkActive="is-active">
          <mat-icon>account_box</mat-icon>
          <span>Profil</span>
        </button>
        @if (authService.getUserRole() === 'ROLE_ADMIN') {
          <button [routerLink]="['/nutzerverwaltung']" mat-menu-item>
            <mat-icon>supervisor_account</mat-icon>
            <span>Nutzerverwaltung</span>
          </button>
        }


        @if (canUseFolders()) {
          <button [routerLink]="['/sammelmappen']" mat-menu-item>
            <mat-icon>folder</mat-icon>
            <span>Sammelmappen</span>
          </button>
        }
        <button [routerLink]="['/benachrichtigungen']" mat-menu-item>
          <mat-icon>notifications</mat-icon>
          <span>Benachrichtigungen</span>
          @if (unreadCount > 0) {
            <span class="unread-dot menu-dot">{{ unreadLabel }}</span>
          }
        </button>
        <button (click)="authService.logoutUser()" [routerLink]="['/']" mat-menu-item routerLinkActive="is-active">
          <mat-icon>logout</mat-icon>
          <span>Abmelden</span>
        </button>
      </mat-menu>
    </div>
  </div>
</mat-toolbar>


<!-- Dropdown Group -->
<mat-menu #menu="matMenu" class="header-menu" yPosition="below" xPosition="after">
  @for (item of dropdownItems; track item) {
    <button [routerLink]="item.route" class="header-menu-button" mat-menu-item
            attr.aria-label="Button zu {{item.name}}">
      <span class="menu-button-group">
        <mat-label class="menu-text">{{ item.name }}</mat-label>
      </span>
    </button>
  }


</mat-menu>
